import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

class GaSettings extends React.Component {
    onGaToggle = (event, analyticsOn) => {
        const { trackingId, onGaChange } = this.props;
        onGaChange({ analyticsOn, trackingId });
    };

    onTrackingIdChanged = event => {
        const { analyticsOn, onGaChange } = this.props;
        const trackingId = event.target.value;
        onGaChange({ analyticsOn, trackingId });
    };

    render() {
        const { analyticsOn, trackingId, classes } = this.props;

        return (
            <div className={classes.wrapper}>
                <FormControlLabel
                    control={
                        <Checkbox
                            color="primary"
                            checked={analyticsOn}
                            onChange={this.onGaToggle}
                        />
                    }
                    key={analyticsOn} // FormControlLabel has a bug and does not refresh it's state if the key is not changed
                    label="Enable Google Analytics for published visualizations in this organization"
                />
                <TextField
                    disabled={!analyticsOn}
                    label="Google tracking ID"
                    margin="normal"
                    value={trackingId || ''}
                    required={analyticsOn}
                    onChange={this.onTrackingIdChanged}
                />
            </div>
        );
    }
}

GaSettings.propTypes = {
    trackingId: PropTypes.string,
    analyticsOn: PropTypes.bool,
};

GaSettings.defaultProps = {
    trackingId: '',
    analyticsOn: false,
};

export const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: spacing.unit * 3,
    },
});

export default injectSheet(style)(GaSettings);



// WEBPACK FOOTER //
// ./src/components/settings/GaSettings.js